module.exports = __webpack_public_path__ + "img/smartEnergy2.87397862.png";